import { lazy } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'

import { App } from '@/components'
import { ProtectedRoute } from './protected_route'

const Address = lazy(() => import('@/pages/address').then(m => ({ default: m.Address })))
const AddressAdd = lazy(() => import('@/pages/address_add').then(m => ({ default: m.AddressAdd })))
const AddressEdit = lazy(() => import('@/pages/address_edit').then(m => ({ default: m.AddressEdit })))
const Article = lazy(() => import('@/pages/article').then(m => ({ default: m.Article })))
const ArticleDetail = lazy(() => import('@/pages/article_detail').then(m => ({ default: m.ArticleDetail })))
const ChangePassword = lazy(() => import('@/pages/change_password').then(m => ({ default: m.ChangePassword })))
const ContactUs = lazy(() => import('@/pages/contact_us').then(m => ({ default: m.ContactUs })))
const ContentLink = lazy(() => import('@/pages/content_link').then(m => ({ default: m.ContentLink })))
const ContentLinkForm = lazy(() => import('@/pages/content_link_form').then(m => ({ default: m.ContentLinkForm })))
const ForgotPassword = lazy(() => import('@/pages/forgot_password').then(m => ({ default: m.ForgotPassword })))
const FunGame = lazy(() => import('@/pages/fun_game').then(m => ({ default: m.FunGame })))
const History = lazy(() => import('@/pages/history').then(m => ({ default: m.History })))
const HistoryDetail = lazy(() => import('@/pages/history_detail').then(m => ({ default: m.HistoryDetail })))
const Home = lazy(() => import('@/pages/home').then(m => ({ default: m.Home })))
const Invite = lazy(() => import('@/pages/invite').then(m => ({ default: m.Invite })))
const Landing = lazy(() => import('@/pages/landing').then(m => ({ default: m.Landing })))
const Language = lazy(() => import('@/pages/language').then(m => ({ default: m.Language })))
const Login = lazy(() => import('@/pages/login').then(m => ({ default: m.Login })))
const Luckydraw = lazy(() => import('@/pages/luckydraw').then(m => ({ default: m.Luckydraw })))
const Notification = lazy(() => import('@/pages/notification').then(m => ({ default: m.Notification })))
const NotificationDetail = lazy(() => import('@/pages/notification_detail').then(m => ({ default: m.NotificationDetail })))
const Otp = lazy(() => import('@/pages/otp').then(m => ({ default: m.Otp })))
const Profile = lazy(() => import('@/pages/profile').then(m => ({ default: m.Profile })))
const ProfileEdit = lazy(() => import('@/pages/profile_edit').then(m => ({ default: m.ProfileEdit })))
const Promo = lazy(() => import('@/pages/promo').then(m => ({ default: m.Promo })))
const PromoDetail = lazy(() => import('@/pages/promo_detail').then(m => ({ default: m.PromoDetail })))
const Quiz = lazy(() => import('@/pages/quiz').then(m => ({ default: m.Quiz })))
const QuizScores = lazy(() => import('@/pages/quiz_scores').then(m => ({ default: m.QuizScores })))
const QuizTerms = lazy(() => import('@/pages/quiz_terms').then(m => ({ default: m.QuizTerms })))
const Redeem = lazy(() => import('@/pages/redeem').then(m => ({ default: m.Redeem })))
const RedeemDetail = lazy(() => import('@/pages/redeem_detail').then(m => ({ default: m.RedeemDetail })))
const Register = lazy(() => import('@/pages/register').then(m => ({ default: m.Register })))
const Reward = lazy(() => import('@/pages/reward').then(m => ({ default: m.Reward })))
const Scan = lazy(() => import('@/pages/scan').then(m => ({ default: m.Scan })))
const Subscription = lazy(() => import('@/pages/subscription').then(m => ({ default: m.Subscription })))
const SubscriptionCheckout = lazy(() => import('@/pages/subscription_checkout').then(m => ({ default: m.SubscriptionCheckout })))
const SubscriptionDetail = lazy(() => import('@/pages/subscription_detail').then(m => ({ default: m.SubscriptionDetail })))
const SubscriptionProduct = lazy(() => import('@/pages/subscription_product').then(m => ({ default: m.SubscriptionProduct })))
const SubscriptionProductDetail = lazy(() => import('@/pages/subscription_product_detail').then(m => ({ default: m.SubscriptionProductDetail })))
const TermsConditions = lazy(() => import('@/pages/terms_conditions').then(m => ({ default: m.TermsConditions })))

export const router = createBrowserRouter(
	[
		{
			path: '/',
			errorElement: <Navigate to="/" replace={true} />,
			element: <App />,
			children: [
				{ path: '', element: <Landing /> },
				{ path: 'article', element: <Article /> },
				{ path: 'article/:id', element: <ArticleDetail /> },
				{ path: 'fun-game', element: <FunGame /> },
				{ path: 'quiz', element: <Quiz /> },
				{ path: 'quiz/scores', element: <QuizScores /> },
				{ path: 'quiz/terms-and-conditions', element: <QuizTerms /> },
				{
					path: 'app',
					element: (
						<ProtectedRoute>
							<Home />
						</ProtectedRoute>
					)
				},
				{ path: 'login', element: <Login /> },
				{ path: 'forgot-password', element: <ForgotPassword /> },
				{ path: 'register', element: <Register /> },
				{ path: 'register/otp', element: <Otp /> },
				{
					path: 'scan',
					element: (
						<ProtectedRoute>
							<Scan />
						</ProtectedRoute>
					)
				},
				{
					path: 'history',
					element: (
						<ProtectedRoute>
							<History />
						</ProtectedRoute>
					)
				},
				{
					path: 'history/:id/detail',
					element: (
						<ProtectedRoute>
							<HistoryDetail />
						</ProtectedRoute>
					)
				},
				{
					path: 'profile',
					element: (
						<ProtectedRoute>
							<Profile />
						</ProtectedRoute>
					)
				},
				{
					path: 'profile/edit',
					element: (
						<ProtectedRoute>
							<ProfileEdit />
						</ProtectedRoute>
					)
				},
				{
					path: 'change-password',
					element: (
						<ProtectedRoute>
							<ChangePassword />
						</ProtectedRoute>
					)
				},
				{
					path: 'invite',
					element: (
						<ProtectedRoute>
							<Invite />
						</ProtectedRoute>
					)
				},
				{
					path: 'history/luckydraw',
					element: (
						<ProtectedRoute>
							<Luckydraw />
						</ProtectedRoute>
					)
				},
				{
					path: 'link/submit',
					element: (
						<ProtectedRoute>
							<ContentLink />
						</ProtectedRoute>
					)
				},
				{
					path: 'link/submit/form',
					element: (
						<ProtectedRoute>
							<ContentLinkForm />
						</ProtectedRoute>
					)
				},
				{
					path: 'notification',
					element: (
						<ProtectedRoute>
							<Notification />
						</ProtectedRoute>
					)
				},
				{
					path: 'notification/:id',
					element: (
						<ProtectedRoute>
							<NotificationDetail />
						</ProtectedRoute>
					)
				},
				{
					path: 'promo',
					element: (
						<ProtectedRoute>
							<Promo />
						</ProtectedRoute>
					)
				},
				{
					path: 'promo/:id/detail',
					element: (
						<ProtectedRoute>
							<PromoDetail />
						</ProtectedRoute>
					)
				},
				{
					path: 'reward',
					element: (
						<ProtectedRoute>
							<Reward />
						</ProtectedRoute>
					)
				},
				{
					path: 'redeem',
					element: (
						<ProtectedRoute>
							<Redeem />
						</ProtectedRoute>
					)
				},
				{
					path: 'redeem/:id/detail',
					element: (
						<ProtectedRoute>
							<RedeemDetail />
						</ProtectedRoute>
					)
				},
				{
					path: 'subscription/product',
					element: (
						<ProtectedRoute>
							<SubscriptionProduct />
						</ProtectedRoute>
					)
				},
				{
					path: 'subscription/product/detail',
					element: (
						<ProtectedRoute>
							<SubscriptionProductDetail />
						</ProtectedRoute>
					)
				},
				{
					path: 'subscription',
					element: (
						<ProtectedRoute>
							<Subscription />
						</ProtectedRoute>
					)
				},
				{
					path: 'subscription/checkout',
					element: (
						<ProtectedRoute>
							<SubscriptionCheckout />
						</ProtectedRoute>
					)
				},
				{
					path: 'subscription/detail',
					element: (
						<ProtectedRoute>
							<SubscriptionDetail />
						</ProtectedRoute>
					)
				},
				{
					path: 'address',
					element: (
						<ProtectedRoute>
							<Address />
						</ProtectedRoute>
					)
				},
				{
					path: 'address/add',
					element: (
						<ProtectedRoute>
							<AddressAdd />
						</ProtectedRoute>
					)
				},
				{
					path: 'address/edit',
					element: (
						<ProtectedRoute>
							<AddressEdit />
						</ProtectedRoute>
					)
				},
				{
					path: 'language',
					element: (
						<ProtectedRoute>
							<Language />
						</ProtectedRoute>
					)
				},
				{
					path: 'contact-us',
					element: (
						<ProtectedRoute>
							<ContactUs />
						</ProtectedRoute>
					)
				},
				{
					path: 'terms-and-conditions',
					element: (
						<ProtectedRoute>
							<TermsConditions />
						</ProtectedRoute>
					)
				}
			]
		}
	]
)
